import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CSVReader from 'react-csv-reader';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import { isAuthenticated, uploadFile, sendLogin } from '../../auth/Auth';
import RegisterButton from '../../components/atoms/RegisterButton';
import { getAccounts, addShopAccount } from '../../actions/Accounts';
import { addShopImage, addRelationShop } from '../../actions/Shop';
import '../../stylesheets/csv.css';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, addShopAccount, addShopImage, addRelationShop },
        dispatch
      )
    })
  ),
  withState('listShop', 'setListShop', null),
  withState('listImage', 'setListImage', null),
  withState('listSuccess', 'setListSuccess', null),
  withState('listFalse', 'setListFalse', null),
  withState('groupId1', 'setGroupId1', null),
  withState('groupId2', 'setGroupId2', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    listShop,
    setListShop,
    listImage,
    setListImage,
    listFalse,
    setListFalse,
    listSuccess,
    setListSuccess,
    groupId1,
    setGroupId1,
    groupId2,
    setGroupId2,
    shopCategories,
    prefectures
  }) => {
    const listSuc = [];
    const listFal = [];

    const shopRelationOkAction = async (groupId, shopId) => {
      const params = {
        groupId,
        shopId
      };
      const relationShop = await actions.addRelationShop(params);
      if (relationShop.type === 'ADD_RELATION_SHOP_SUCCESS') {
        return 'ok';
      }
      return '';
    };

    const addShopAction = async (addParam, numin) => {
      const delay = 1000;
      await new Promise(resolve => setTimeout(resolve, delay * numin));
      const addedShop = await actions.addShopAccount(addParam);
      const addImage = {};
      let num = 0;
      let shopIdCreate = '';
      if (typeof addedShop.payload.shop !== 'undefined') {
        shopIdCreate = addedShop.payload.shop.shopId;
      }
      if (listImage) {
        Object.keys(listImage).map(async k => {
          if (
            listImage[k] !== null &&
            parseInt(
              listImage[k].name.substring(0, listImage[k].name.indexOf('_')),
              10
            ) === numin &&
            num < 5
          ) {
            addImage[num] = listImage[k];
            num += 1;
          }
        });
        console.log(addImage);

        const imagePaths = await Promise.all(
          Object.keys(addImage).map(async i => {
            if (
              addImage[i] !== null &&
              typeof addedShop.payload.shop !== 'undefined'
            ) {
              const image = addImage[i];
              const imagePath = await uploadFile(
                'shop',
                addedShop.payload.shop.shopId,
                image,
                'public'
              );
              return imagePath;
            }
            return null;
          })
        );
        const images = imagePaths
          .filter(i => i !== null)
          .map((i, index) => {
            return { image: i, viewOrder: index };
          });
        if (Object.keys(images).length !== 0) {
          await actions.addShopImage(addedShop.payload.shop.shopId, {
            images
          });
        }
      }

      if (addedShop.type === 'ADD_SHOP_ACCOUNT_SUCCESS') {
        // release shop with group
        let relationShop1 = null;
        let relationShop2 = null;
        if (groupId1) {
          relationShop1 = shopRelationOkAction(groupId1, shopIdCreate);
        }
        if (groupId2) {
          relationShop2 = shopRelationOkAction(groupId2, shopIdCreate);
        }
        console.log(
          `shop with email: ${addParam.email} ,${`${
            addParam.email
          } ,${shopIdCreate}`} success create`
        );
        listSuc.push(
          `${addParam.email} ,${shopIdCreate} ,${
            relationShop1 ? groupId1 : ''
          } ,${relationShop2 ? groupId2 : ''}`
        );
      } else {
        console.log(`shop with email: ${addParam.email}, false create`);
        listFal.push(`${addParam.email} ,${shopIdCreate} , , `);
      }
    };

    const registerAction = async () => {
      if (listShop.length > 0) {
        const arr = [];
        for (let index = 0; index < listShop.length; index += 1) {
          let prefectureCode = '';
          let shopCategoryId = '';
          for (let k = 0; k < prefectures.length; k += 1) {
            if (
              listShop[index].prefectureCode &&
              prefectures[k].name
                .toString()
                .includes(listShop[index].prefectureCode.toString())
            ) {
              prefectureCode = prefectures[k].id;
            }
          }
          for (let u = 0; u < shopCategories.length; u += 1) {
            if (
              listShop[index].shopCategoryId &&
              shopCategories[u].name
                .toString()
                .includes(listShop[index].shopCategoryId.toString())
            ) {
              shopCategoryId = shopCategories[u].id;
            }
          }

          let contactPhone = '';
          if (listShop[index].contactPhone) {
            if (listShop[index].contactPhone.toString().charAt(0) === '0') {
              contactPhone = `${listShop[index].contactPhone}`;
            } else {
              contactPhone = `0${listShop[index].contactPhone}`;
            }
          }

          let phone = '';
          if (listShop[index].phone) {
            if (listShop[index].phone.toString().charAt(0) === '0') {
              phone = `${listShop[index].phone}`;
            } else {
              phone = `0${listShop[index].phone}`;
            }
          }

          const addParam = {
            access: listShop[index].access || '',
            address: listShop[index].address || '',
            bankAccount: {
              bankAccountHolder: listShop[index].bankAccountHolder || '',
              bankAccountNumber: listShop[index].bankAccountNumber || '',
              bankAccountType: listShop[index].bankAccountType || 'SAVINGS',
              bankBranchName: listShop[index].bankBranchName || '',
              bankName: listShop[index].bankName || ''
            },
            building: listShop[index].building || '',
            businessHours: listShop[index].businessHours || '',
            city: listShop[index].city || '',
            cognitoUserId: listShop[index].cognitoUserId || '',
            contactPhone: contactPhone || '',
            department: listShop[index].department || '',
            depositManage: listShop[index].depositManage || 'NONSELF',
            email: listShop[index].email || '',
            forcePassChanged: true,
            gochiRestriction: 'MENTION_ONLY',
            groupId: listShop[index].groupId || null,
            holiday: listShop[index].holiday || '',
            images: {
              0: { image: null, viewOrder: 0 },
              1: { image: null, viewOrder: 1 },
              2: { image: null, viewOrder: 2 },
              3: { image: null, viewOrder: 3 },
              4: { image: null, viewOrder: 4 }
            },
            inviteUserId: listShop[index].inviteUserId || '',
            nearestStation: listShop[index].nearestStation || '',
            numberSit: listShop[index].numberSit || '',
            parking: listShop[index].parking || '',
            phone: phone || '',
            prefectureCode: prefectureCode || '',
            priceRange: listShop[index].priceRange || '',
            shopCategoryId: shopCategoryId || '',
            shopContactName: listShop[index].shopContactName || '',
            shopGroupName: listShop[index].shopGroupName || '',
            shopName: listShop[index].shopName || '',
            shopNameKana: listShop[index].shopNameKana || '',
            smoking: listShop[index].smoking || '',
            snsFacebook: listShop[index].snsFacebook || '',
            snsInstagram: listShop[index].snsInstagram || '',
            snsTwitter: listShop[index].snsTwitter || '',
            stealthMode: 'UNSTEALTH',
            tags: listShop[index].tags || null,
            webPage: listShop[index].webPage || '',
            zipCode: listShop[index].zipCode || '',
            introduction: listShop[index].introduction || '',
            showPhone: 1,
            suntoryFlag: 1
          };
          arr.push(
            addShopAction(
              addParam,
              listShop[index].no
                ? parseInt(listShop[index].no.replace('店舗目', ''), 10)
                : 1
            )
          );
        }
        await Promise.all(arr);
      }
    };

    const create = () => {
      registerAction().then(() => {
        console.log('1');
        console.log(listFal);
        setListSuccess(listSuc);
        setListFalse(listFal);
      });
    };

    const handleForce = data => {
      console.log(data);
      setListShop(data);
    };

    const onChangeFileHandler = event => {
      console.log(event.target.files);
      if (event.target.files.length > 0) {
        const dataImg = {};
        const fileArr = Object.values(event.target.files);
        fileArr.sort(function compare(a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
        for (let m = 0; m < fileArr.length; m += 1) {
          dataImg[m] = fileArr[m];
        }
        setListImage(dataImg);
      }
    };

    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      encoding: 'Shift-JIS'
    };

    return (
      <div className="box-create">
        <h2>Tool Upload CSV data to create Multi-Shops</h2>
        <br />
        <br />
        <CSVReader
          cssClass="csv-reader-input"
          label="Select CSV shop create"
          onFileLoaded={handleForce}
          inputId="csvShop"
          inputStyle={{ color: 'red' }}
          parserOptions={papaparseOptions}
        />
        {listShop && (
          <div className="csv-reader-input">
            <p>Input Group relation shop</p>
            <p>Group 1</p>
            <input
              className="group"
              type="text"
              name="groupId1"
              onChange={e => {
                setGroupId1(e.target.value);
              }}
            />
            <p>Group 2</p>
            <input
              className="group"
              type="text"
              name="groupId1"
              onChange={e => {
                setGroupId2(e.target.value);
              }}
            />
          </div>
        )}
        {listShop && (
          <div className="csv-reader-input">
            <p>Select image of shop create</p>
            <input
              className="csv-input"
              type="file"
              name="file"
              multiple
              accept="image/*"
              onChange={onChangeFileHandler}
            />
          </div>
        )}
        {listShop && (
          <div>
            <br />
            {listSuccess && (
              <ul>
                {listSuccess.map(item => (
                  <li className="text-success">{item}</li>
                ))}
              </ul>
            )}
            {listFalse && (
              <ul>
                {listFalse.map(item => (
                  <li className="text-false">{item}</li>
                ))}
              </ul>
            )}
            <RegisterButton onClickAction={create} />
          </div>
        )}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
